module.exports = __webpack_public_path__ + "img/order-ico.427e2e59.svg";